<!-- @veltra/icons generated sha256:e7e0d42a1b288701 gen:8 source:src/svg/normal/warning-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'WarningFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0M8.5 4.508v4.484a.51.51 0 0 1-.504.508.51.51 0 0 1-.496-.508V4.508A.51.51 0 0 1 8.004 4c.268 0 .496.232.496.508M7.999 11h.013c.332 0 .582.273.582.604 0 .323-.25.596-.582.596H8a.61.61 0 0 1-.605-.604c0-.323.273-.596.605-.596"
    />
  </svg>
</template>
